import { css } from 'styled-components'

export const borderCurve = `0% 0% 65% 65% / 0% 0% 14% 14%`

export const backDropStyle = css`
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
`
